import { eponaQuery } from '@/helpers/graphql_modules/epona';
import { getUserDisciplinesQuery } from '@/store/queries/pegasus-epona.queries';

export interface ModuleWithDisciplines {
  moduleId: string;
  name: string;
  displayName?: string;
  type: 'REGULAR' | 'COMPLEMENTAR' | 'ELETIVA';
  disciplines: {
    id: string;
    slug: string;
    name: string;
    disciplineInstanceId?: string;
    isMigrated: boolean;
    studyWindowId?: string;
  }[];
}

export class UserDisciplinesService {
  static async getModulesWithDisciplinesByCourseId(
    courseId: string,
  ): Promise<ModuleWithDisciplines[]> {
    const {
      data: {
        getUserDisciplines: { data },
      },
    } = await eponaQuery(getUserDisciplinesQuery, { courseId });

    return data;
  }
}
